/* Read Shopify-rendered active chips; never submit or modify filter URLs. */
(() => {
  if (window.kmFilterTriggerCount) return;
  window.kmFilterTriggerCount = true;
  function init() {
    const listing = document.querySelector('[data-ntajax-container][data-has-filters]');
    if (!listing) return;
    function update() {
      const button = document.querySelector('.bee-collection-header .bee-btn-filter');
      if (!button) return;
      const count = listing.querySelectorAll('.bee-active-filters__remove-filter').length;
      let badge = button.querySelector('.km-filter-trigger-count');
      if (!count) { if (badge) badge.remove(); return; }
      if (!badge) { badge = document.createElement('span'); badge.className = 'km-filter-trigger-count'; button.append(badge); }
      if (badge.textContent !== String(count)) {
        badge.textContent = String(count);
        badge.setAttribute('aria-label', count + ' etkin filtre');
      }
    }
    update();
    new MutationObserver(update).observe(listing, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
